import axios from 'axios'

export default {
  namespaced: true,
  state: {
    topics: [],
    topic: [],
    users: [],
    user: [],
  },
  getters: {
    topics:(state)=>state.topics,
    topic:(state)=>state.topic,
    users:(state)=>state.users,
    user:(state)=>state.user,
  },
  mutations: {
    topics (state, data) {
      state.topics = data
    },
    topicRegister (state, data) {
      state.topic = data.topic
    },
    topicDelete (state) {
      state.topic = [];
    },
    users (state, data) {
      state.users = data
    },
    userRegister (state, data) {
      state.user = data.user
    },
    userDelete (state) {
      state.user = [];
    },
  },
  actions: {
    async topics({ commit }) {
      const response = await axios.get(process.env.VUE_APP_API_BASE_URL + '/favorite_topic/')
      commit('topics', response.data)
      return response.data
    },
    async topicRegister({ commit }, topic) {
      const response = await axios.post(process.env.VUE_APP_API_BASE_URL + '/favorite_topic/' + topic.topic_code)
      response.data.topic = topic;
      commit('topicRegister', response.data)
    },
    async topicDelete({ commit }, topic) {
      await axios.delete(process.env.VUE_APP_API_BASE_URL + '/favorite_topic/' + topic.topic_code)
      commit('topicDelete')
    },
    async users({ commit }) {
      const response = await axios.get(process.env.VUE_APP_API_BASE_URL + '/favorite_user/')
      commit('users', response.data)
      return response.data
    },
    async userRegister({ commit }, user) {
      const response = await axios.post(process.env.VUE_APP_API_BASE_URL + '/favorite_user/' + user)
      response.data.user = user;
      commit('userRegister', response.data)
    },
    async userDelete({ commit }, user) {
      await axios.delete(process.env.VUE_APP_API_BASE_URL + '/favorite_user/' + user)
      commit('userDelete')
    },
  },
}